import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SeoIntro from "./sections/SeoIntro";
import Services from "./sections/Services";
import Studio from "./sections/Studio";
import Methodology from "./sections/Methodology";
import CostTransparency from "./sections/CostTransparency";
import Evolution from "./sections/Evolution";
import Insights from "./sections/Insights";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <SeoIntro />
      <Services />
      <Studio />
      <Methodology />
      <CostTransparency />
      <Evolution />
      <Insights />
      <Consultation />
      <Footer />
    </div>;
}